import useFormatCurrencyForItinerary from '@/src/hooks/currency/useFormatCurrencyForItinerary'
import useFareCards from '@/src/hooks/itinerary/useFareCards'
import { getBrandName } from '@/src/utils/buildUtils'
import { Divider } from '@mui/material'
import { useTranslations } from 'next-intl'
import { FareCards } from './fareCards'

const FareCardsWrapper = () => {
    const { faresToDisplay, onFareSelect, formatFareTitle, fareFamilyEnabledOnReview } = useFareCards()
    const { formatCurrency } = useFormatCurrencyForItinerary()
    const t = useTranslations('common')
    const tVariants = useTranslations('variants')
    const brandName = tVariants(getBrandName())
    if (fareFamilyEnabledOnReview || !Array.isArray(faresToDisplay) || faresToDisplay.length < 2) {
        return null
    }

    return (
        <>
            <Divider sx={{ my: { xs: 0, lg: 2 }, display: { xs: 'none', lg: 'block' } }} />
            <FareCards
                fares={faresToDisplay}
                onFareSelect={onFareSelect}
                formatFareTitle={formatFareTitle}
                formatCurrency={formatCurrency}
                brandName={brandName}
                t={t}
            />
        </>
    )
}

export default FareCardsWrapper
